import React, {useState} from 'react'


import DonutChart from '../subcomponents/DonutChart'
import GlobalPortfolio from '../portfolios/GlobalPortfolio';
import ExchangesPortfolio from "../portfolios/ExchangesPortfolio"
import ShortLongPortfolio from "../portfolios/ShortLongPortfolio"
import PairsPortfolio from "../portfolios/PairsPortfolio"



  const portfolio = {
    "binance": {"BTCUSDT": 1000000, 'ETHUSDT': 200000, 'SOLUSDT': 300000, "WOOFUSDT": 400000 , "WAVEUSDT":12000, "ALICEUSDT": 18000, "GALAUSDT": 23000, "APEUSDT": 80000, "JASMYUSDT": 56000, "CELRUSDT": 34500, "AUDIOUSDT": 6400, "COMUSDT": 28, "BLURUSDT": 12, "ALPHAUSDT": 0.03, "HFTUSDT": 567, "API3USDT": 1890, "XRPUSDT": 115030, "GTCUSDT": 6359, "TRUUSDT": 12.36},
    "bybit": {"BTCUSDT": 800000, 'ETHUSDT': 100000, 'SOLUSDT': 30000, "WOOFUSDT": 4000 , "WAVEUSDT":120000, "ALICEUSDT": 1800, "GALAUSDT": 2300, "APEUSDT": 63700, "JASMYUSDT": 5000, "CELRUSDT": 346500, "AUDIOUSDT": 16400, "COMUSDT": 0.28, "BLURUSDT": 112, "ALPHAUSDT": 0.03, "HFTUSDT": 50.67, "API3USDT": 18.90, "XRPUSDT": 115.03, "GTCUSDT": 6359, "TRUUSDT": 12.36} 
  };

function Portfolio() {
  const [activeTab, setActiveTab] = useState('global_portfolio');

    const renderContent = () => {
      switch (activeTab) {
          case 'global_portfolio':
              return <GlobalPortfolio/>
          case 'pairs_portfolio':
              return <PairsPortfolio/>
          case 'short_long':
              return <ShortLongPortfolio/>
          case 'exchanges_portfolio':
              return <ExchangesPortfolio/>
          default:
              return null;
      }
  };

  return (
    <div className='widget_body'>
      <ul className="widget_tab_nav">
        <li className={activeTab === "global_portfolio" ? "active_widget_tab li no_drag": "li no_drag"} onClick={() => setActiveTab('global_portfolio')}><span>Global</span></li>
        <li className={activeTab === "pairs_portfolio" ? "active_widget_tab li no_drag": "li no_drag"} onClick={() => setActiveTab('pairs_portfolio')}><span>Pairs</span></li>
        <li className={activeTab === "short_long" ? "active_widget_tab li no_drag": "li no_drag"} onClick={() => setActiveTab('short_long')}><span>Short/Long</span></li>
        <li className={activeTab === "exchanges_portfolio" ? "active_widget_tab li no_drag": "li no_drag"} onClick={() => setActiveTab('exchanges_portfolio')}><span>Exchanges</span></li>
      </ul>
     
      {renderContent()}
        
    </div>
  )
}

export default Portfolio


// const data = {
//     labels: ['Red', 'Blue', 'Yellow', 'Green', 'Purple', 'Orange'],
//     datasets: [
//       {
//         label: '# of Votes',
//         data: [12, 19, 3, 5, 2, 3],
//         backgroundColor: [
//           'rgba(255, 99, 132, 0.2)',
//           'rgba(54, 162, 235, 0.2)',
//           'rgba(255, 206, 86, 0.2)',
//           'rgba(75, 192, 192, 0.2)',
//           'rgba(153, 102, 255, 0.2)',
//           'rgba(255, 159, 64, 0.2)',
//         ],
//         borderColor: [
//           'rgba(255, 99, 132, 1)',
//           'rgba(54, 162, 235, 1)',
//           'rgba(255, 206, 86, 1)',
//           'rgba(75, 192, 192, 1)',
//           'rgba(153, 102, 255, 1)',
//           'rgba(255, 159, 64, 1)',
//         ],
//         borderWidth: 1,
//       },
//     ],
//   };

//   const options = {
//     responsive: true,
//     maintainAspectRatio: false,
//     cutoutPercentage: 50,
//   };